var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.182,
    height: 50
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.49 50a3.552 3.552 0 01-2.531-1.024L1.168 32.703a3.709 3.709 0 115.123-5.364l11.571 8.257a1.509 1.509 0 002.23-.241L47.514 1.484a3.7 3.7 0 015.906 4.46l-30.977 42.55a3.693 3.693 0 01-2.652 1.446.544.544 0 01-.3.06z",
    fill: "#6f9d20"
  })));
}

export default __webpack_public_path__ + "5995e22123af5881b6655b051af52afc.svg";
export { SvgTick as ReactComponent };